import { render, staticRenderFns } from "./DeptNoticeRecord.vue?vue&type=template&id=e78ed304&scoped=true"
import script from "./DeptNoticeRecord.vue?vue&type=script&lang=js"
export * from "./DeptNoticeRecord.vue?vue&type=script&lang=js"
import style0 from "./DeptNoticeRecord.vue?vue&type=style&index=0&id=e78ed304&prod&scoped=true&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78ed304",
  null
  
)

export default component.exports